/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { CreateJobPayload } from 'api/actions/create-job/create-job-payload';
import { CreateJobPathParameters } from 'api/actions/create-job/create-job-path-parameters';
import { CreateJobResponse } from 'api/actions/create-job/create-job-response';

type CreateJobQueryParameters = Record<string, any>;

/**
 * The path of the CreateJob action.
 */
export const createJobActionPath = new SweetPath<keyof CreateJobPathParameters>('/help-desk/jobs/', {
  path: '{param}',
});

/**
 * Creates a contextualized CreateJob actions.
 */
export default function createCreateJobAction(axios: AxiosInstance) {
  return function createJobAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: CreateJobQueryParameters;
    payload: CreateJobPayload;
  }) {
    const path = createJobActionPath.original;

    return axios.post<CreateJobResponse, CreateJobResponse, CreateJobPayload>(path, payload);
  };
}
